export default (str: string = ''): string => {
    const arr = str.trim().split(' ');

    return arr.filter((n, i) => !!n && arr.indexOf(n) === i).join(' ');
}
